import React, {memo, useEffect, useState} from 'react';
import {View} from 'react-native';

import {Divider} from 'react-native-elements'; // rne-netzon replaced
import {RNEText, SVGIcon} from '../../components';

import {
  Menu,
  MenuOptions,
  MenuOption,
  MenuTrigger,
} from 'react-native-popup-menu';

import {
  doctorCompletedConsultationPopoverItems,
  doctorOngoingConsultationPopoverItems,
  popoverOptionsStyles,
  popoverOptionStyles,
  popoverDividerStyle,
  PopoverItemKey,
  IPopoverItem,
} from './data/popoverItems.data';

import {ConsultationStatusEnum} from '../../server/types/consultation.types';

interface ConsultationDoctorPopoverProps {
  status: ConsultationStatusEnum;
  onMenuItemClick?: (itemKey: PopoverItemKey) => void;
}

const ConsultationDoctorPopover = (props: ConsultationDoctorPopoverProps) => {
  const [menuList, setMenuList] = useState<IPopoverItem[]>([]);

  useEffect(() => {
    switch (props.status) {
      case ConsultationStatusEnum.ONGOING:
        setMenuList(doctorOngoingConsultationPopoverItems);
        break;

      case ConsultationStatusEnum.COMPLETED:
        setMenuList(doctorCompletedConsultationPopoverItems);
        break;

      default:
        setMenuList([]);
        break;
    }
  }, [props.status]);

  const onItemClick = (itemKey: PopoverItemKey) => {
    if (props.onMenuItemClick) {
      props.onMenuItemClick(itemKey);
    }
  };

  return (
    <Menu rendererProps={{preferredPlacement: 'bottom'}}>
      <MenuTrigger>
        <SVGIcon name="option-gray" />
      </MenuTrigger>
      <MenuOptions customStyles={popoverOptionsStyles}>
        {menuList.map((item, index) => (
          <View key={index}>
            {index > 0 && <Divider style={popoverDividerStyle} />}

            <MenuOption
              customStyles={popoverOptionStyles}
              onSelect={() => onItemClick(item.itemKey)}>
              <RNEText label={item.label} variant="button" weight="600" />
            </MenuOption>
          </View>
        ))}
      </MenuOptions>
    </Menu>
  );
};

export default memo(ConsultationDoctorPopover);
